module.exports = __webpack_public_path__ + "img/wenti_banner_hk.2ea58225.jpg";